import ExpandAllButton, {
  EXPAND_MODE_EXPANDED,
  EXPAND_MODE_COLLAPSED,
} from '../../common/components/List/ExpandAllButton.js'
import {
  setExpandedTransferIDs,
  setExpandMode,
  expandModeSelector,
  expandedTransferIDsSelector,
} from './transferListFunctions.js'
import {useSelector} from '../../store.js'

export default function TransferExpandAll() {
  const expandMode = useSelector(expandModeSelector)
  const expandedMOCount = useSelector(expandedTransferIDsSelector).length

  const shouldCollapse =
    expandedMOCount > 1 || expandMode === EXPAND_MODE_EXPANDED

  return (
    <li
      className="inline-block margin-right-3 tooltip--top"
      data-hint={
        shouldCollapse ? 'Collapse all Transfers' : 'Expand all Transfers'
      }
    >
      <ExpandAllButton
        className="meta-transferlistheader-button-expandall"
        shouldCollapse={shouldCollapse}
        onExpandAll={() => {
          setExpandedTransferIDs([])
          setExpandMode(EXPAND_MODE_EXPANDED)
        }}
        onCollapseAll={() => {
          setExpandedTransferIDs([])
          setExpandMode(EXPAND_MODE_COLLAPSED)
        }}
      />
    </li>
  )
}
